import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  AMENITIES_EDIT,
  AMENITIES_TAB_LIST,
  UPLOAD_PDF,
} from '../../../../../constants/AmenityConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_AMENITIES,
} from '../../../../../constants/RoleConsts';
import CustomPhoneNoView from '../../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allAmenitiesSelector,
  allAmenityCategoriesSelector,
} from '../../../../property/propertySlice';
import RedirectUrlLink from '../../../../../shared/redirect-url-link/Redirect-Url-Link';
import CustomDocumentViewer from '../../../../../shared/custom-document-viewer/Custom-Document-Viewer';

const AmenitiesView = (props) => {
  const { amenity, onViewToggle, hotelId, toggleDrawer, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const [selectedAmenity, setSelectedAmenity] = useState();
  const originalAmenities = useSelector(allAmenitiesSelector);
  const originalCategories = useSelector(allAmenityCategoriesSelector);

  useEffect(() => {
    let amenityObj = {
      ...originalAmenities.find((obj) => obj.id === amenity.id),
    };
    amenityObj['category'] = originalCategories?.find((c) => c.id === amenityObj.categoryId);
    setSelectedAmenity(amenityObj);
  }, [hotelId, originalAmenities]);

  const onClickEdit = (event) => {
    toggleDrawer(AMENITIES_EDIT, true, selectedAmenity);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const getCategoryNames = (categoryIds) => {
    const displayName = categoryIds?.map(
      (itemData) => originalCategories?.find((category) => category?.id === itemData)?.name,
    );
    return displayName ? <span>{displayName.join(', ')}</span> : '';
  };

  const renderDetailsValue = (item) => {
    if (!item ?? !item?.type ?? !item?.value) {
      return null;
    }
    switch (item?.type) {
      case 'PHONE':
        return <CustomPhoneNoView value={item?.value} />;
      case 'EMAIL':
        return item?.value;
      case 'PDF':
        if (item?.value?.startsWith('http')) {
          return <RedirectUrlLink url={item?.value} />;
        }
        return (
          <CustomDocumentViewer
            document={{
              url: item?.value,
              type: 'S3',
            }}
            title={item?.field || item?.displayTitle}
          />
        );
      default:
        return <RedirectUrlLink url={item?.value} />;
    }
  };
  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <>
            <div className='row mx-4 mt-4'>
              <div className='col-md-6'>
                <div className='details-label'>Hotel Compendium Name</div>
                <div className='details-value preview-breaks'>{selectedAmenity?.name}</div>
              </div>
              <div className='col-md-6'>
                <div className='details-label'>Status</div>
                <div className='details-value'>
                  <div
                    className={`${
                      selectedAmenity.isActive ? 'pill-active' : 'pill-inactive'
                    } col-md-3 pill-text pill mt-3`}
                  >
                    <span>{selectedAmenity?.isActive ? 'Active' : 'Inactive'}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Category Name</div>
                <div className='details-value'>{getCategoryNames(selectedAmenity.categoryIds)}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>{selectedAmenity?.description}</div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              <div className='col-md-12'>
                <div className='details-label'>Highlight</div>
                <div className='details-value'>
                  {selectedAmenity?.highlights?.length > 1
                    ? selectedAmenity?.highlights?.map((highlight, i) => (
                        <div key={i}>- {highlight}</div>
                      ))
                    : selectedAmenity?.highlights?.[0]
                    ? selectedAmenity?.highlights?.[0]
                    : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {selectedAmenity?.customAttributes &&
                selectedAmenity?.customAttributes?.length > 0 &&
                selectedAmenity?.customAttributes?.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item?.key}</div>
                    <div className='details-value'>{item?.value}</div>
                  </div>
                ))}
            </div>
          </>
        )}
        {tabValue === 1 && (
          <>
            {selectedAmenity.information?.map((item, i) => (
              <div className='row mx-4 mt-4' key={i}>
                <div className='col-md-6'>
                  <div className='details-label'>
                    {item?.type === 'PDF'
                      ? `${UPLOAD_PDF}${item?.displayTitle ? ` - ${item?.displayTitle}` : ''}`
                      : `${item?.field} - ${item?.displayTitle}`}
                  </div>

                  <div className='details-value'>{renderDetailsValue(item)}</div>
                </div>
              </div>
            ))}
            {(!selectedAmenity.information || selectedAmenity.information.length === 0) && (
              <div className='row mx-4 mt-4'>
                <div className='col-md-12'>No data Available</div>
              </div>
            )}
          </>
        )}
        {tabValue === 2 && (
          <>
            <div className='row pt-4 px-3'>
              <MediaViewer
                images={selectedAmenity?.images}
                videos={selectedAmenity?.videos}
                gifs={selectedAmenity?.gifs}
                enabledMediaTabs={['image']}
              />
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      {selectedAmenity && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={AMENITIES_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedAmenity?.name}
          createdUserId={selectedAmenity?.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_AMENITIES] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default AmenitiesView;
